/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import proptypes from 'prop-types';
const { func, string, bool, oneOfType } = proptypes;
import { Typography, Link, IconButton } from '@one-thd/sui-atomic-components';
import { ArrowBack, ConfirmedFilled, Close } from '@one-thd/sui-icons';
import { partsAndServicesDataModel } from '../partsAndServicesDataModel';
import { usePartsAndServices } from '../PartsAndServicesProvider';
import { POST_MESSAGE, PAGE_TYPE } from '../../constants';
import { postMessageToParent } from '../../utils';

export const Header = ({
  onBack,
  onClose,
  headerText,
  showSuccessCheck
}) => {
  const { productsMap, isPSPPServiceDown, currentPage } = usePartsAndServices();
  const numItems = productsMap?.size || 0;
  const isConfirmation = currentPage === PAGE_TYPE.CONFIRMATION;
  const ExitButton = (
    <IconButton
      onClick={() => {
        postMessageToParent({ message: POST_MESSAGE.CLOSED });
        if (onClose) {
          onClose();
        }
      }}
      icon={Close}
      buttonSize="tight"
      iconSize="small"
      data-testid="exit-button"
      aria-label="Exit & Save"
    />
  );

  if (!numItems && !isPSPPServiceDown && !isConfirmation) {
    return (
      <div className="sui-flex sui-justify-end sui-py-3 sui-px-4 sui-shadow-md">
        {ExitButton}
      </div>
    );
  }

  return (
    <div
      data-testid="parts-and-services-header"
      className="sui-px-4 sui-py-3 sui-shadow-md sui-w-full sui-z-max sui-fixed sui-top-0 sui-paper"
    >
      {!!onBack && (
        <div data-testid="back-button" className="sui-flex sui-justify-between sui-items-center sui-mb-2">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link
            className="sui-flex sui-items-center sui-gap-2 sui-text-base"
            component="button"
            underline="none"
            onClick={onBack}
          >
            <div className="sui-flex sui-items-center">
              <ArrowBack size="small" />
            </div>
            Back
          </Link>
          {ExitButton}
        </div>
      )}
      <div className="sui-flex sui-justify-between sui-items-center">
        <div className="sui-flex sui-items-center">
          {showSuccessCheck && (
            <span className="sui-pr-2 sui-relative sui-top-[3px]">
              <ConfirmedFilled color="success" data-testid="check-icon" aria-label="Success Icon" />
            </span>
          )}
          <span>
            {headerText && (
              <Typography
                component="span"
                variant="h2"
                role="heading"
                aria-level="2"
                data-testid="header-text"
              >
                {headerText}
              </Typography>
            )}
            <span className="sui-pl-2">
              {!!numItems && (
                <Typography
                  component="span"
                  variant="body-base"
                  data-testid="num-items"
                >
                  {`(${numItems}`}&nbsp;{`Item${numItems !== 1 ? 's' : ''})`}
                </Typography>
              )}
            </span>
          </span>
        </div>
        {!onBack && ExitButton}
      </div>
    </div>
  );
};

Header.propTypes = {
  onBack: oneOfType([func, bool]),
  onClose: oneOfType([func, bool]),
  headerText: string.isRequired,
  showSuccessCheck: bool
};

Header.defaultProps = {
  onBack: null,
  onClose: null,
  showSuccessCheck: false
};

Header.dataModel = partsAndServicesDataModel;

Header.displayName = 'Header';
